import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
} from "vue-router";
import LoginComponent from "@/components/forms/LoginComponent.vue";
import OtpAuthCOmponent from "@/components/forms/OtpAuthCOmponent.vue";
import SendPwdResetMailComponent from "@/components/forms/SendPwdResetMailComponent.vue";
import PwdUpdateComponent from "@/components/forms/PwdUpdateComponent.vue";
import PortalTopComponent from "@/components/forms/PortalTopComponent.vue";
import AboutComponent from "@/components/layout/AboutComponent.vue";
import AdminTopComponent from "@/components/forms/AdminTopComponent.vue";
import ContentsDetailComponent from "@/components/forms/ContentsDetailComponent.vue";
import SitetSerchComponent from "@/components/forms/SitetSerchComponent.vue";
import AgSegmentRegComponent from "@/components/forms/AgSegmentRegComponent.vue";
import AgUserMaintenanceComponent from "@/components/forms/AgUserMaintenanceComponent.vue";
import AgUserMaintenanceListComponent from "@/components/forms/AgUserMaintenanceListComponent.vue";
import ContentsRegComponent from "@/components/forms/ContentsRegComponent.vue";
import OneStopGideTopComponent from "@/components/forms/OneStopGideTopComponent.vue";
import TemporaryPage from "@/components/forms/TemporaryPage.vue";
import OverTimeComponent from "@/components/forms/OverTimeComponent.vue";
import LogOutComponent from "@/components/forms/LogoutComponent.vue";
import IncentiveComponent from "@/components/forms/IncentiveComponent.vue";
import SkilupTopComponent from "@/components/forms/SkilupTopComponent.vue";
import ToranomakiComponent from "@/components/forms/ToranomakiComponent.vue";
import SkilupEventComponent from "@/components/forms/SkilupEventComponent.vue";
import EventDetailComponent from "@/components/forms/EventDetailComponent.vue";
import LoginPopupListComponent from "@/components/forms/LoginPopupListComponent.vue";
import LoginPopupRegComponent from "@/components/forms/LoginPopupRegComponent.vue";
import GlobalNaviManegmentComponent from "@/components/forms/GlobalNaviManegmentComponent.vue";
import GlobalNaviManegmentListComponent from "@/components/forms/GlobalNaviManegmentListComponent.vue";
import IconMenuManegmentComponent from "@/components/forms/IconMenuManegmentComponent.vue";
import IconMenuManegmentListComponent from "@/components/forms/IconMenuManegmentListComponent.vue";
import BannerRegComponent from "@/components/forms/BannerRegComponent.vue";
import BannerRegListComponent from "@/components/forms/BannerRegListComponent.vue";
import SkilupRegComponent from "@/components/forms/SkilupRegComponent.vue";
import EventRegComponent from "@/components/forms/EventRegComponent.vue";
import EventEntryDownloadComponent from "@/components/forms/EventEntryDownloadComponent.vue";
import GlobalNaviPreviewComponent from "@/components/forms/GlobalNaviPreviewComponent.vue";
import OneStopGideMaintenanceComponent from "@/components/forms/OneStopGideMaintenanceComponent.vue";
import IconMenuPreviewComponent from "@/components/forms/IconMenuPreviewComponent.vue";
import CustomerSerchComponent from "@/components/forms/CustomerSerchComponent.vue";
import BaseIncentiveRedirectComponent from "@/components/forms/BaseIncentiveRedirectComponent.vue";
import ApplicationMGListKaunetComponent from "@/components/forms/ApplicationMGListKaunetComponent.vue";
import ApplicationMGListAGComponent from "@/components/forms/ApplicationMGListAgComponent.vue";
import ApplicationMGAgComponent from "@/components/forms/ApplicationMGAgComponent.vue";
import ApplicationMGKaunetComponent from "@/components/forms/ApplicationMGKaunetComponent.vue";

import logService from "@/services/logService";
import { useUserStore } from "@/store/userStore";
import { AppConstants } from "@/constants/AppConstants";
import { outputDebugLogs, isTokenAlive } from "@/Common";
import apiClientAuth from "@/util/apiClientAuth";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import { isWithinOperationHours } from "@/util/operationHours";

const routes = [
  {
    // TOP
    path: "/",
    name: "Home",
    component: PortalTopComponent,
    meta: { requiresAuth: true, breadcrumb: "Home", systemCatName: "Home" }, // このページは認証が必要
  },
  {
    // ログイン
    path: "/login",
    name: "Login",
    component: LoginComponent,
  },
  {
    // ログイン（ワンタイムパスワード認証）
    path: "/login-otp",
    name: "Otp",
    component: OtpAuthCOmponent,
  },
  {
    // ログアウト
    path: "/logout",
    name: "Logout",
    component: LogOutComponent,
  },
  {
    // パスワードリセットメール送信
    path: "/password-reset",
    name: "PwdReset",
    component: SendPwdResetMailComponent,
  },
  {
    // パスワード変更
    path: "/password-update/token/:token",
    name: "PwdUpdate",
    component: PwdUpdateComponent,
    props: true,
  },
  {
    // ポータルトップ
    path: "/portal-top",
    name: "PortalTop",
    component: PortalTopComponent,
    meta: { requiresAuth: true, breadcrumb: "Home", systemCatName: "Home" }, // このページは認証が必要
  },
  {
    // サイト内検索
    path: "/site-serch",
    name: "SiteSerch",
    component: SitetSerchComponent,
    meta: { requiresAuth: true, breadcrumb: "サイト内検索" }, // このページは認証が必要
  },
  {
    // カテゴリのみの検索
    path: "/site-serch/categoryId/:categoryId",
    name: "SiteSerch2",
    component: SitetSerchComponent,
    meta: { requiresAuth: true }, // このページは認証が必要
    props: true,
  },
  {
    // お知らせ
    path: "/news",
    name: "News",
    component: SitetSerchComponent,
    meta: {
      requiresAuth: true,
      breadcrumb: "お知らせ",
      systemCatName: "お知らせ",
    }, // このページは認証が必要
  },
  {
    // よくある質問
    path: "/faq",
    name: "FAQ",
    component: SitetSerchComponent,
    meta: {
      requiresAuth: true,
      breadcrumb: "よくある質問",
      systemCatName: "よくある質問",
    }, // このページは認証が必要
  },
  {
    // 申請書
    path: "/application-form",
    name: "ApplicationForm",
    component: SitetSerchComponent,
    meta: {
      requiresAuth: true,
      breadcrumb: "申請書",
      systemCatName: "申請書",
    }, // このページは認証が必要
  },
  {
    // 提案書
    path: "/proposal",
    name: "Proposal",
    component: SitetSerchComponent,
    meta: {
      requiresAuth: true,
      breadcrumb: "提案書",
      systemCatName: "提案書",
    }, // このページは認証が必要
  },
  {
    // 帳票・マニュアル
    path: "/manual",
    name: "Manual",
    component: SitetSerchComponent,
    meta: {
      requiresAuth: true,
      breadcrumb: "帳票・マニュアル",
      systemCatName: "帳票・マニュアル",
    }, // このページは認証が必要
  },
  {
    // 管理者TOP
    path: "/kanrisya-top",
    name: "AdminTop",
    component: AdminTopComponent,
    meta: { requiresAuth: true, systemCatName: "管理者TOP" }, // このページは認証が必要
  },
  {
    // コンテンツ詳細
    path: "/contents/categoryId/:categoryId/contentsId/:contentsId",
    name: "Contents",
    component: ContentsDetailComponent,
    props: true,
    meta: { requiresAuth: true, breadcrumb: "詳細" }, // このページは認証が必要
  },
  {
    // コンテンツ詳細(虎の巻から)
    path: "/contents/categoryId/:categoryId/contentsId/:contentsId/ismodal/:ismodal",
    name: "ContentsToramonaki",
    component: ContentsDetailComponent,
    props: true,
    meta: { requiresAuth: true, breadcrumb: "詳細" }, // このページは認証が必要
  },
  {
    // AGセグメント登録
    path: "/agsegment-reg",
    name: "AgSegmentReg",
    component: AgSegmentRegComponent,
    meta: { requiresAuth: true, systemCatName: "AGセグメント登録" }, // このページは認証が必要
  },
  {
    // AG一般ユーザー登録
    path: "/aguser-maintenance",
    name: "AgUserMaintenanceList",
    component: AgUserMaintenanceListComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "AG一般ユーザー登録",
    }, // このページは認証が必要
  },
  {
    // AG一般ユーザー登録
    path: "/aguser-reg",
    name: "AgUserMaintenance",
    component: AgUserMaintenanceComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "AG一般ユーザー登録",
    }, // このページは認証が必要
  },
  {
    // お知らせ登録
    path: "/notification-reg",
    name: "NotificationReg",
    component: ContentsRegComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "お知らせ登録",
    }, // このページは認証が必要
  },
  {
    // 管理者からのお知らせ登録
    path: "/kanrisya-notification-reg",
    name: "AdminNotificationReg",
    component: ContentsRegComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "管理者からのお知らせ登録",
    }, // このページは認証が必要
  },
  {
    // ワンストップガイド
    path: "/one-stop-gide",
    name: "OneStopGideTop",
    component: OneStopGideTopComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "ワンストップガイド",
      breadcrumb: "ワンストップガイド",
    }, // このページは認証が必要
  },
  {
    // スキルアップトップ（動画一覧）
    path: "/skilup-video-list",
    name: "SkilupTop",
    component: SkilupTopComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "スキルアップトップ",
    }, // このページは認証が必要
  },
  {
    // スキルアップ虎の巻
    path: "/skilup-toranomaki",
    name: "Toranomaki",
    component: ToranomakiComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "スキルアップ虎の巻",
    }, // このページは認証が必要
  },
  {
    // スキルアップイベント一覧
    path: "/skilup-event-list",
    name: "EventList",
    component: SkilupEventComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "スキルアップイベント一覧",
    }, // このページは認証が必要
  },
  {
    // スキルアップイベント詳細
    path: "/skilup-event-detail/categoryId/:categoryId/contentsId/:contentsId",
    name: "EventDetail",
    component: EventDetailComponent,
    props: true,
    meta: {
      requiresAuth: true,
      systemCatName: "スキルアップイベント詳細",
    }, // このページは認証が必要
  },
  {
    // ログイン時ポップアップ一覧
    path: "/login-popup-list",
    name: "LoginPopupList",
    component: LoginPopupListComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "ログイン時ポップアップ一覧",
    }, // このページは認証が必要
  },
  {
    // ログイン時ポップアップ登録
    path: "/login-popup-reg",
    name: "LoginPopupReg",
    component: LoginPopupRegComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "ログイン時ポップアップ登録",
    }, // このページは認証が必要
  },
  {
    path: "/about",
    name: "About",
    // ルートコンポーネントの指定が必要です。
    component: AboutComponent,
  },
  {
    path: "/error-page",
    name: "ErrorPage",
    component: AboutComponent,
  },
  {
    path: "/temporary",
    name: "Temporary",
    component: TemporaryPage,
  },
  {
    // 運用時間外
    path: "/out-of-operation",
    name: "OutOfOperation",
    component: OverTimeComponent,
  },
  {
    // 奨励金
    path: "/incentive",
    name: "Incentive",
    component: IncentiveComponent,
  },
  {
    // グローバルナビ管理
    path: "/glovalnavi-kanri",
    name: "GlovalnaviKanri",
    component: GlobalNaviManegmentComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "グローバルナビ管理",
    }, // このページは認証が必要
  },
  {
    // グローバルナビ管理一覧
    path: "/glovalnavi-kanri-list",
    name: "GlovalnaviKanriList",
    component: GlobalNaviManegmentListComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "グローバルナビ管理一覧",
    }, // このページは認証が必要
  },
  {
    // アイコンメニュー管理
    path: "/iconmenu-kanri",
    name: "IconmenuKanri",
    component: IconMenuManegmentComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "アイコンメニュー管理",
    }, // このページは認証が必要
  },
  {
    // アイコンメニュー管理
    path: "/iconmenu-kanri-list",
    name: "IconmenuKanriList",
    component: IconMenuManegmentListComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "アイコンメニュー管理一覧",
    }, // このページは認証が必要
  },
  {
    // バナー登録
    path: "/banner-touroku",
    name: "BannerTouroku",
    component: BannerRegComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "バナー登録",
    }, // このページは認証が必要
  },
  {
    // バナー登録リスト
    path: "/banner-touroku-list",
    name: "BannerTourokuList",
    component: BannerRegListComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "バナー登録リスト",
    }, // このページは認証が必要
  },
  {
    // スキルアップ登録
    path: "/skilup-touroku",
    name: "SkilupReg",
    component: SkilupRegComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "スキルアップ登録",
    }, // このページは認証が必要
  },
  {
    // イベント登録
    path: "/event-touroku",
    name: "EventReg",
    component: EventRegComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "イベント登録",
    }, // このページは認証が必要
  },
  {
    // イベント申込み情報ダウンロード
    path: "/event-entry-dl",
    name: "EventEntryDL",
    component: EventEntryDownloadComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "イベント申込み情報ダウンロード",
    }, // このページは認証が必要
  },
  {
    // グローバルナビプレビュー
    path: "/preview-globalnavi/glovalNaviKanriId/:glovalNaviKanriId/detailKbn/:detailKbn",
    name: "PreviewGlobalNavi",
    component: GlobalNaviPreviewComponent,
    props: true,
    meta: {
      requiresAuth: true,
      systemCatName: "グローバルナビプレビュー",
    }, // このページは認証が必要
  },
  {
    // アイコンメニュープレビュー
    path: "/preview-iconmenu/iconMenuKanriId/:iconMenuKanriId/detailKbn/:detailKbn",
    name: "PreviewIconMenu",
    component: IconMenuPreviewComponent,
    props: true,
    meta: {
      requiresAuth: true,
      systemCatName: "アイコンメニュープレビュー",
    }, // このページは認証が必要
  },
  {
    // ワンストップガイド管理
    path: "/one-stop-gide_kanri",
    name: "",
    component: OneStopGideMaintenanceComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "ワンストップガイド管理",
    }, // このページは認証が必要
  },
  {
    // 顧客検索
    path: "/customer-serch",
    name: "",
    component: CustomerSerchComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "登録企業検索",
    }, // このページは認証が必要
  },
  {
    // 奨励金（ベースからの遷移）
    path: "/with-incentive",
    name: "with-incentive",
    component: BaseIncentiveRedirectComponent,
  },
  {
    // 申請状況一覧（KAUNET）
    path: "/shinsei-kanri-kaunet",
    name: "",
    component: ApplicationMGListKaunetComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "申請管理（KAUNET）",
    }, // このページは認証が必要
  },
  {
    // 申請状況一覧（申請側）
    path: "/shinsei-kanri-ag",
    name: "",
    component: ApplicationMGListAGComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "申請管理（申請側）",
    }, // このページは認証が必要
  },
  {
    // 申請画面（申請側）
    path: "/shinseiform-ag",
    name: "",
    component: ApplicationMGAgComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "申請画面（申請側）",
    }, // このページは認証が必要
  },
  {
    // 申請画面（申請側）
    path: "/shinseiform-ag/appNo/:appNo",
    name: "",
    component: ApplicationMGAgComponent,
    props: true,
    meta: {
      requiresAuth: true,
      systemCatName: "申請画面（申請側）",
    }, // このページは認証が必要
  },
  {
    // 申請画面（受領側）
    path: "/shinseiform-kaunet",
    name: "",
    component: ApplicationMGKaunetComponent,
    meta: {
      requiresAuth: true,
      systemCatName: "申請画面（受領側）",
    }, // このページは認証が必要
  },
  {
    // 申請画面（受領側）
    path: "/shinseiform-kaunet/appNo/:appNo",
    name: "",
    component: ApplicationMGKaunetComponent,
    props: true,
    meta: {
      requiresAuth: true,
      systemCatName: "申請画面（受領側）",
    },
  },
  // 他のルート定義...
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 遷移前の URL を保存するための変数
let previousUrl = "";
let previousListUrl = "";

// 遷移元のルーター情報を保存するための変数
let prevRoute: RouteLocationNormalized | null = null;

function isTargetOutOfOperation(toName: string) {
  if (toName == "OutOfOperation") {
    return false;
  }

  if (toName == "ErrorPage") {
    return false;
  }

  return true;
}

function isUpdatePreviousUrl(toName: string) {
  // ログインは戻り先URLとして保存しない
  if (toName == "Login") {
    return false;
  }

  // お知らせ登録は戻り先のURLとして保存しない
  if (toName == "NotificationReg") {
    return false;
  }

  return true;
}

router.beforeEach(async (to, from, next) => {
  outputDebugLogs("beforeEach");
  const fromName = typeof from.name === "string" ? from.name : "";
  const toName = typeof to.name === "string" ? to.name : "";

  outputDebugLogs("fromName:" + fromName);
  outputDebugLogs("toName:" + toName);
  outputDebugLogs("beforeEach");

  if (from.fullPath) {
    // 戻り先URLを保存する場合
    if (isUpdatePreviousUrl(fromName)) {
      previousUrl = from.fullPath;
    }

    if (
      (toName == "Contents" || toName == "EventDetail") &&
      isUpdatePreviousUrl(fromName)
    ) {
      previousListUrl = from.fullPath;
    }
  }

  // 運用時間外チェック
  try {
    outputDebugLogs("toName:" + toName);
    if (isTargetOutOfOperation(toName) && !(await isWithinOperationHours())) {
      outputDebugLogs("システム運用時間外");
      next({ name: "OutOfOperation" });
      return;
    }
  } catch (error) {
    alert(messages.ERR_SYS999);
    next("/error-page");
    return;
  }

  const { logoutUser } = useUserStore();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const systemCatName = to.meta.systemCatName || "";
  const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
  let isLoggedIn = false;

  // ローディングインディケーターを表示
  showLoadingIndicator(true);

  if (systemCatName) {
    // システムカテゴリ名が設定されているものは権限チェックする Todo
    outputDebugLogs("systemCatName:" + systemCatName);
  }

  if (requiresAuth) {
    if (!userInfo) {
      // ログイン後に元の画面に戻れるようにする
      next({ name: "Login", query: { redirect: to.fullPath } });
    } else {
      try {
        outputDebugLogs("USERID：" + JSON.parse(userInfo).userId);

        // トークン有効性チェック
        if (await isTokenAlive()) {
          isLoggedIn = JSON.parse(userInfo).isLoggedIn || false;

          if (!isLoggedIn) {
            logoutUser();
            next({ name: "Login", query: { redirect: to.fullPath } });
          } else {
            // 各画面の権限があるかをここでチェックする
            next();
          }
        } else {
          logoutUser();
          alert(messages.ERR_USER001);
          next({ name: "Login", query: { redirect: to.fullPath } });
        }
      } catch (error) {
        outputDebugLogs("エラー内容:" + error);
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          // サーバーからのレスポンスがある場合
          if (axiosError.response.status === 401) {
            alert(messages.ERR_USER001);
          } else {
            alert(messages.ERR_SYS999);
          }
        } else if (axiosError.request) {
          alert(messages.ERR_USER001);
        } else {
          // その他のエラー
          alert(messages.ERR_SYS999);
        }

        // 型アサーションを使用してエラーをログに出力
        outputDebugLogs((error as Error).toString());
        logoutUser();
        next({ name: "Login", query: { redirect: to.fullPath } });
      }
    }
  } else {
    next();
  }

  // ローディングインディケーターを非表示
  showLoadingIndicator(false);
  // 遷移元のルーター情報を保存
  prevRoute = from;
});

function showLoadingIndicator(show: boolean) {
  // ローディングインディケーターの表示/非表示を制御する関数
  const loadingIndicator = document.getElementById("loading-indicator");
  if (loadingIndicator) {
    loadingIndicator.style.display = show ? "block" : "none";
  }
}

router.afterEach((to, from) => {
  outputDebugLogs("afterEach");
  outputDebugLogs(
    "from.fullPath == to.fullPath:" + (from.fullPath == to.fullPath)
  );

  const fromName = typeof from.name === "string" ? from.name : "";

  if (from.fullPath == "/") {
    return;
  }

  if (from.fullPath == to.fullPath) {
    if (fromName == "Contents" || fromName == "EventDetail") {
      outputDebugLogs("previousListUrl:" + previousListUrl);
      outputDebugLogs("router.push(previousListUrl)");
      router.push(previousListUrl);
      previousListUrl = "";
      return;
    }

    return;
  }
  const { loadFromLocalStorage } = useUserStore();
  loadFromLocalStorage();
  const userStore = useUserStore();

  // 画面遷移のログを出力
  const logData = {
    systemkbn: process.env.VUE_APP_SYSTEM_KBN,
    userId: userStore.state.userId || "0000000000",
    agCode: userStore.state.agCode || "00000000",
    actionTime: new Date().toISOString(),
    operationType: AppConstants.OP_TYPE_TRANS,
    pseudoAgCode: userStore.state.pseudoAgCode,
    pseudoUserId: userStore.state.pseudoUserId,
    fromScreenName: from.name?.toString() ?? "未定義",
    toScreenName: to.name?.toString() ?? "未定義",
    controlName: "",
    actionDetail: `画面遷移: ${from.path} から ${to.path}`,
    genericField1: "",
    genericField2: "",
    genericField3: "",
    currentUrl: window.location.href,
  };

  logService.sendLog(logData);
});

// 遷移前の URL に戻る関数
export function goBackToPreviousUrl() {
  outputDebugLogs("【 previousUrl 】:" + previousUrl);
  outputDebugLogs("【 previousListUrl 】:" + previousListUrl);
  if (previousUrl) {
    router.push(previousUrl);
  } else {
    router.push("/portal-top");
  }
}

export function getPreviousUrl(): string | null {
  return previousUrl;
}

// 遷移元のルーター情報を返却する関数
export function getPrevRoute(): RouteLocationNormalized | null {
  return prevRoute;
}

export default router;
